import angular from 'angular';
import { MeurhSolicitacoesvtsadicionaisService } from './solicitacoesvtsadicionais.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhSolicitacoesvtsadicionaisListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhSolicitacoesvtsadicionaisService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhSolicitacoesvtsadicionaisService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_solicitacoesvtsadicionais'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                        const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_solicitacoesvtsadicionais'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_solicitacoesvtsadicionais_not_found', $stateParams)) {
                                    $state.go('meurh_solicitacoesvtsadicionais_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_solicitacoesvtsadicionais', {
            url: '/solicitacoes/vtsadicionais?q?tipo',
            template: require('html-loader!./index/solicitacoesvtsadicionais.index.html'),
            controller: 'Meurh\SolicitacoesvtsadicionaisIndexController',
            controllerAs: 'mrh_slctcsvtsdcns_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_solicitacoesvtsadicionais_new', {
            parent: 'meurh_solicitacoesvtsadicionais',
            url: '/new',
            template: require('html-loader!./new/solicitacoesvtsadicionais.new.html'),
            controller: 'MeurhSolicitacoesvtsadicionaisNewController',
            controllerAs: 'mrh_slctcsvtsdcns_frm_nw_cntrllr'
        })
        .state('meurh_solicitacoesvtsadicionais_show', {
            parent: 'meurh_solicitacoesvtsadicionais',
            url: '/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/solicitacoesvtsadicionais.show.html'),
            controller: 'MeurhSolicitacoesvtsadicionaisShowController',
            controllerAs: 'mrh_slctcsvtsdcns_frm_shw_cntrllr'
        })
        .state('meurh_solicitacoesvtsadicionais_edit', {
            parent: 'meurh_solicitacoesvtsadicionais',
            url: '/:solicitacao/edit',
            resolve,
            template: require('html-loader!./edit/solicitacoesvtsadicionais.edit.html'),
            controller: 'Meurh\SolicitacoesvtsadicionaisEditController',
            controllerAs: 'mrh_slctcsvtsdcns_frm_edit_cntrllr'
        });
    }
];
